import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import 'select2';
import { SapCdcForm } from '../../sapcdc-form/js/sapcdc-form';
import * as Cookies from 'js-cookie';
import { SapCdcFormGlobal } from '../../sapcdc-form-global/js/sapcdc-form-global';

const classes = {
	buttonItem: 'js-m-contact-teaser-buttons__btn',
	popup: 'js-m-contact-teaser-buttons__popup',
	popupClose: 'js-m-contact-teaser-buttons__popup-close',
	popupMask: 'js-m-contact-teaser-buttons__popup-mask',
	statusPopupActive: 'status-m-contact-teaser-buttons__popup--visible',
	submitForm: 'js-form__button-event--submit',
	cancelForm: 'js-form__button-event--cancel',
	focusElement: 'js-form__event-show-additional-fields',
	additionalFields: 'js-form__additional-fields',
	stateFormOrderAdditionalFieldsVisible: 'state-m-teaser-contact-form--show-additional-fields',
	stateFormOrderHiddenAfterSubmit: 'state-m-teaser-contact-form--hidden-after-submit',
	inputSelect: 'js-form__input-select',
	input: 'js-form__input',
	inputCheckBox: 'a-input-checkbox__input',
	inquiryTypeInputSelect: 'js-form__input-inquiry-type',
	sdsLinkColumn: 'js-o-form__grid-col-sds-link',
	inquiryTextboxColumn: 'js-o-form__grid-col-inquiry-textbox',
	buttonItemReloadForm: 'js-m-contact-teaser-buttons__btn-click-reload-form',
	inputSelectCategoryType: 'js-form__input-category-type',
	inputSelectCheckMark: 'a-input-select--global-has-check',
	categoryInputContainer: 'o-form__grid-col--input-category',
	categoryInputField: 'js-a-input--category',
};

const optionValues = {
	other: 'other',
	productSafetyDataSheets: 'product safety data sheets',
};

interface SapCdcCdpContactExpertFormData {
	primaryEmail: any;
	firstName: any;
	lastName: any;
	cov_submission_src: any;
	cov_submission_type: any;
	cov_submission_date: any;
	cov_industry: any;
	cov_lead_comments: any;
	cov_form_url: any;
	cov_cookie_id: any;
	cov_inquiry_type: any;
	cov_material: any;
	cov_campaign_id: any;
	cdc_token_item_path: any;
	cdc_set_acc_item_path: any;
	country: any;
	company: any;
}

@createModule('ContactTeaserButtons')
/**
 * @author
 */
export class ContactTeaserButtons extends TerrificSpec {
	$ctx: JQuery;
	$inputSelect: JQuery;
	$inputCheckBox: JQuery;
	$input: JQuery;
	$buttonItemsReloadForm: any;

	focusFromScrollReached: boolean = false;
	sapCdcService: SapCdcFormGlobal;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		const $buttonItem = this.$ctx.find(`.${classes.buttonItem}`);
		this.$buttonItemsReloadForm = $(this.$ctx.find(`.${classes.buttonItemReloadForm}`));
		const $popup = this.$ctx.find(`.${classes.popup}`);
		const $popupClose = this.$ctx.find(`.${classes.popupClose}`);
		const $popupMask = this.$ctx.find(`.${classes.popupMask}`);
		this.sapCdcService = new SapCdcFormGlobal();
		if (this.$buttonItemsReloadForm.length > 0) {
			this.$buttonItemsReloadForm.each((i: any, e: JQuery<HTMLButtonElement>) => {
				$(e).on('click', (event: Event) => this.showPopupReloadForm(event));
			});
		}
		$buttonItem.on('click', this.showPopup.bind(this));

		$popupClose.on('click', this.hidePopup.bind(this));
		$popupMask.on('click', this.hidePopup.bind(this));

		$popup.each((i, e) => {
			const name = '#' + $(e).attr('id');
			if (window.location.hash.length > 0 && name == window.location.hash) {
				$(e).addClass(classes.statusPopupActive);
			}
		});

		const formID = this.$ctx.attr('id');
		$('#requestasamplesitecoreform').hide();
		$('#requestaquotesitecoreform').hide();
		this.initFormHadling();

		this.onClickAnchor();
		this.onClickLink($('.js-m-stage-product__button'));
		if ($('.js-m-stage-product__button').length > 0) {
			this.onClickLink($('.js-m-navigation-in-page__cta'));
		}

		$('.js-m-navigation-in-page__list-items').on('click', '[href="#' + formID + '"]', (ev: Event) => {
			ev.preventDefault();
			this.onFocusAreaFocus();
			this.$ctx.find(`.${classes.focusElement}`).focus();
		});
		// this.$ctx.on('scrollReached', this.onScrollReached.bind(this)); //remove feature again due to customer request

		if (this.$ctx.data('api-endpoint')) {
			this.prefillFormData();
		}

		this.$inputSelect = this.$ctx.find(`.${classes.inputSelect}`);
		this.$inputCheckBox = this.$ctx.find(`.${classes.inputCheckBox}`);
		this.$input = this.$ctx.find(`.${classes.input}`);
		this.$inputSelect.on('change', (ev: Event) => this.inputSelecteOptionChanged(ev));
		this.addOtherOptionForMaterialTag();
		this.setMaterialTagDefaultValue();

		//Click button to open the form
		this.onClickPopupAnchor();
		this.onPageLoadCheckForm();

		resolve();
	}

	showPopup(ev: Event) {
		const $this = $(ev.currentTarget);
		if (this.$buttonItemsReloadForm.length > 0 && Cookies.get('initialSapCdcGlobalCall') === undefined && Cookies.get('cdcUserData') !== undefined && Cookies.get('cdcProfileData') !== undefined) {
			$this
				.next()
				.find('.m-sapcdc-form')
				.hide();
		}
		$this.next().addClass(classes.statusPopupActive);

		const form = $(ev.currentTarget)
			.next()
			.find('form')[0] as HTMLFormElement;

		Cookies.remove('initialSapCdcGlobalCall');

		if (form) {
			const formId = $(form).attr('id'); // Get the form ID
			const scformName = $(form).find("input[data-sc-field-name='HiddenFormName']").length
				? $(form)
						.find("input[data-sc-field-name='HiddenFormName']")
						.val()
				: '';
			const scSendDataToGtm = $(form).find("input[data-sc-field-name='SendDataToGTM']").length
				? $(form)
						.find("input[data-sc-field-name='SendDataToGTM']")
						.val()
				: false;

			let formName = scformName
				? scformName
				: $(form).attr('data-form-name') !== undefined
					? $(form).attr('data-form-name')
					: '';
			const sendDataToGtm =
				scSendDataToGtm !== undefined && scSendDataToGtm === 'Yes'
					? true
					: $(form).attr('data-sc-send-data-to-gtm') && $(form).attr('data-sc-send-data-to-gtm') === 'true'
						? true
						: false;

			if (sendDataToGtm) {
				const trackdata: {
					event: string;
					form_id: string;
					form_name: string;
					form_destination: string;
					form_submit_text: string;
				} = {
					event: 'form_start',
					form_id: formId,
					form_name: formName.toString(),
					form_destination: '',
					form_submit_text: '',
				};
				Track.gtmTrack(trackdata);
			}
		}
	}

	showPopupReloadForm(ev: Event) {
		$('#requestasamplesitecoreform').hide();
		$('#requestaquotesitecoreform').hide();
		if (
			Cookies.get('cdcUserData') !== undefined &&
			Cookies.get('cdcProfileData') !== undefined &&
			Cookies.get('initialSapCdcGlobalCall') === undefined
		) {
			this.showIndicator(ev);
			const $this = $(ev.currentTarget)
				.next()
				.find('.m-sapcdc-form');
			const sapCdcForm = new SapCdcForm();
			sapCdcForm.formId = $this.data('form-id');
			sapCdcForm.ppFormId = $this.data('pp-form-id');
			sapCdcForm.screenSetId = $this.data('screen-set-id');
			sapCdcForm.contextLang = $this.data('context-language');
			sapCdcForm.$blockedMessage = $this.find("p[data-id='blockedMsg']") as JQuery<HTMLElement>;
			var formContainerId = '#sapCdcForm_' + sapCdcForm.formId;
			$(formContainerId).empty();
			console.log('Reload form Started');
			let _this = this;
			let eventData = ev;
			$($($this).next()).load(location.href + ' #' + $this.next().attr('id'), function() {
				let formElementLoaded: boolean = false;
				if (formElementLoaded === false) {
					console.log('Reload form Done');
					console.log('Cdc form load started Started');
					sapCdcForm.loadSapCdcForm(
						sapCdcForm.formId,
						sapCdcForm.screenSetId,
						sapCdcForm.contextLang,
						sapCdcForm.$errorMsg
					);
					$($this).show();
					console.log('Cdc form load started Done');
					_this.hideIndicator(eventData);
				}
			});
		}
	}

	showIndicator(ev: Event) {
		$(ev.currentTarget)
				.next().append(`
			<div class="o-form__spinner js-o-form__spinner">
				<div class="a-loading-indicator">
					<div class="a-loading-indicator__one"></div>
					<div class="a-loading-indicator__two"></div>
					<div class="a-loading-indicator__three"></div>
				</div>
			</div>`);
	}

	hideIndicator(eventData: any) {
		$(eventData.currentTarget)
				.next().find('.js-o-form__spinner').remove();
	}

	hidePopup(ev: Event) {
		const $this = $(ev.currentTarget);
		$this.closest(`.${classes.popup}`).removeClass(classes.statusPopupActive);
	}

	onClickPopupAnchor() {
		$('html')
			.find('a')
			.on('click', (ev: any) => {
				const anchor = $(ev.currentTarget);
				const url = anchor.attr('href');
				const idx = url !== undefined ? url.indexOf('#') : -1;

				if (idx === 0) {
					const target = $(url.substring(idx));
					if (target.length === 1 && target.hasClass(classes.popup)) {
						target.addClass(classes.statusPopupActive);
					}

					this.triggerGAFormStartEvent(target);
				} else {
					const divId =
						url !== undefined ? (url.indexOf('#') !== -1 ? url.split('#')[1] : undefined) : undefined;
					if (divId !== undefined) {
						let divElement = $('#' + divId);

					if (divElement !== undefined && divElement.length === 1
						&& divElement.hasClass(classes.popup)) {
						divElement.addClass(classes.statusPopupActive);
					}

					this.triggerGAFormStartEvent(divElement);
				}
			}
		});
	}

	onPageLoadCheckForm() {
		var hashId = window.location.hash;
		if (hashId) {
			const target = $(hashId);
			this.triggerGAFormStartEvent(target);
		}
	}

	triggerGAFormStartEvent(htmlControl: JQuery<HTMLElement>) {
		const form = $(htmlControl).find('form')[0] as HTMLFormElement;
		if (form) {
			const formId = $(form).attr('id'); // Get the form ID
			const scformName = $(form).find("input[data-sc-field-name='HiddenFormName']").length
				? $(form)
						.find("input[data-sc-field-name='HiddenFormName']")
						.val()
				: '';
			const scSendDataToGtm = $(form).find("input[data-sc-field-name='SendDataToGTM']").length
				? $(form)
						.find("input[data-sc-field-name='SendDataToGTM']")
						.val()
				: false;

			let formName = scformName
				? scformName
				: $(form).attr('data-form-name') !== undefined
					? $(form).attr('data-form-name')
					: '';
			const sendDataToGtm =
				scSendDataToGtm !== undefined && scSendDataToGtm === 'Yes'
					? true
					: $(form).attr('data-sc-send-data-to-gtm') && $(form).attr('data-sc-send-data-to-gtm') === 'true'
						? true
						: false;

			if (sendDataToGtm) {
				const trackdata: {
					event: string;
					form_id: string;
					form_name: string;
					form_destination: string;
					form_submit_text: string;
				} = {
					event: 'form_start',
					form_id: formId,
					form_name: formName.toString(),
					form_destination: '',
					form_submit_text: '',
				};
				Track.gtmTrack(trackdata);
			}
		}
	}

	hiddenSubmitForm(hiddenForm: any) {
		if (hiddenForm.length > 0) {
			let formId = hiddenForm;
			let formName = jQuery('div[data-form-id="' + formId + '"] form').attr('data-form-name');
			const trackdata: {
				event: string;
				form_id: string;
				form_name: string;
				form_destination: string;
				form_hidden_submit_text: string;
			} = {
				event: 'hidden_form_submit',
				form_id: formId,
				form_name: formName.toString(),
				form_destination: '',
				form_hidden_submit_text: '',
			};
			Track.gtmTrack(trackdata);
		}
	}
	initFormHadling() {
		this.$ctx.on('focus', `.${classes.focusElement}`, this.onFocusAreaFocus.bind(this));
		this.$ctx.on('click', `.${classes.cancelForm}`, this.onCancleClick.bind(this));
		this.$ctx.on('click', `.${classes.submitForm}`, this.onFormSubmit.bind(this));
	}

	onFocusAreaFocus() {
		this.$ctx.find(`.${classes.additionalFields}`).addClass(classes.stateFormOrderAdditionalFieldsVisible);
		if (!this.focusFromScrollReached) {
			if ($('.js-m-navigation-in-page__wrapper').length > 0) {
				scrollToElement(this.$ctx, true, $('.js-m-navigation-in-page__wrapper').height() + 20);
			} else {
				scrollToElement(this.$ctx, true, 70);
			}
		} else {
			this.focusFromScrollReached = false;
		}
		$(window).trigger('NavigationInPage:reInitNoClick');
	}

	onCancleClick() {
		this.$ctx.find(`.${classes.additionalFields}`).removeClass(classes.stateFormOrderAdditionalFieldsVisible);
		scrollToElement(this.$ctx, true);
	}

	onFormSubmit(ev: Event) {
		var validate = true;
		let $currentForm = $(ev.currentTarget).closest('form');
		let $currentFormInputSelect: any = $($currentForm).find(`.${classes.inputSelect}`);
		let $currentFormInput: any = $($currentForm).find(`.${classes.input}`);
		let $currentFormInputCheckBox: any = $($currentForm).find(`.${classes.inputCheckBox}`);

		$currentFormInputSelect.each(function(index: any, item: any) {
			var dataValRequired = $(item).attr('data-val');
			if (typeof dataValRequired !== 'undefined' && dataValRequired !== '' && dataValRequired !== null) {
				if ($(item).val() == '') {
					$(item).addClass('state-a-input--has-error');
					$(item)
						.nextAll('.field-validation-valid')
						.text($(item).attr('data-val-required'));
					$(item)
						.nextAll('.field-validation-valid')
						.addClass('field-validation-error');
					validate = false;
				}
			}
		});

		$currentFormInput.each(function(index: any, item: any) {
			var dataValRequired = $(item).attr('data-val');
			if (typeof dataValRequired !== 'undefined' && dataValRequired !== '' && dataValRequired !== null) {
				if ($(item).val() == '') {
					$(item).addClass('input-validation-error');
					$(item)
						.nextAll('.field-validation-valid')
						.addClass('field-validation-error');
					$(item)
						.nextAll('.field-validation-valid')
						.text($(item).attr('data-val-required'));
					validate = false;
				}
			}
		});

		$currentFormInputCheckBox.each(function(index: any, item: any) {
			var dataValRequired = $(item).attr('data-val');
			if (typeof dataValRequired !== 'undefined' && dataValRequired !== '' && dataValRequired !== null) {
				if (!$(item).is(':checked')) {
					$(item).addClass('input-validation-error');
					validate = false;
				}
			}
		});

		if (validate) {
			const divContainer: any = $(ev.currentTarget).closest('div.m-contact-teaser-buttons__popup-container');
			const hiddenMktoForm: any =
				$(divContainer).find("div[data-t-name='MarketoForm']") !== undefined &&
				$(divContainer).find("div[data-t-name='MarketoForm']").length > 0
					? $(divContainer).find("div[data-t-name='MarketoForm']")
					: [];
			const hiddenMarketoFormSubmitAllowed: any = $(hiddenMktoForm).attr('data-allow-hidden-form-submit');

			const hiddenCdcForms: any = $(divContainer).find("div[class='o-form']");
			const hiddenCdcFormSubmitAllowed: any = $(hiddenCdcForms).attr('data-allow-hidden-form-submit');

			var urlParams = new URLSearchParams(window.location.search);
			var utmId = '';
			if (urlParams.has('utm_id')) {
				utmId = urlParams.get('utm_id');
			}
			let campaignId: string =
				typeof utmId === 'string' && utmId.length === 0
					? $(hiddenCdcForms).attr('data-sap-cdc-form-campaign-id')
					: utmId;

			let materialTagValue = $(divContainer)
				.find("[data-sc-field-name='materialTag']")
				.val();
			let industryTagValue = $(divContainer)
				.find("[data-sc-field-name='industryType']")
				.val();
			var firstName = $(divContainer)
				.find("[data-sc-field-name='FirstName']")
				.val();
			var lastName = $(divContainer)
				.find("[data-sc-field-name='LastName']")
				.val();
			var email = $(divContainer)
				.find("[data-sc-field-name='Email']")
				.val();
			var country = $(divContainer)
				.find("[data-sc-field-name='Country']")
				.val();
			var company = $(divContainer)
				.find("[data-sc-field-name='Company']")
				.val();
			var formMessage = $(divContainer)
				.find("[data-sc-field-name='Text']")
				.val();
			var submissionSource = $(divContainer)
				.find("[data-sc-field-name='SubmissionSource']")
				.val();
			var submissionType = $(divContainer)
				.find("[data-sc-field-name='SubmissionType']")
				.val();
			let inquiryType =
				$(divContainer)
					.find("[data-sc-field-name='InquiryType']")
					.val() !== undefined &&
				$(divContainer)
					.find("[data-sc-field-name='InquiryType']")
					.val() === 'Other'
					? $(divContainer)
							.find("[data-sc-field-name='otherInquiryType']")
							.val()
					: $(divContainer)
							.find("[data-sc-field-name='InquiryType']")
							.val();
			var tokenOprationItemPath = $(divContainer)
				.find("[data-sc-field-name='TokenOprationItemPath']")
				.val();
			var setAccinfoOprationItemPath = $(divContainer)
				.find("[data-sc-field-name='SetAccinfoOprationItemPath']")
				.val();

			var myHiddenMetaDataString = $(divContainer)
				.find(`#dynamicDataSourceFieldsJsonString`)
				.text();
			let myHiddenMetaData: any;
			if (myHiddenMetaDataString.length > 0) {
				myHiddenMetaDataString = myHiddenMetaDataString.replace('][', ',');
				myHiddenMetaData = JSON.parse(myHiddenMetaDataString);
			}

			if (hiddenMarketoFormSubmitAllowed === 'true') {
				let MktoForms2 = (window as any)['MktoForms2'];
				if (typeof MktoForms2 != 'undefined') {
					var mktoFormId = $(hiddenMktoForm[0]).attr('data-form-id');
					let myHiddenMktoForm: any = MktoForms2.getForm(mktoFormId);
					let myHiddenFormFields: any = myHiddenMktoForm.vals();

					if (typeof myHiddenFormFields != 'undefined') {
						myHiddenMktoForm.addHiddenFields({
							//These are the values which will be submitted to Marketo
							formMessage: formMessage,
							FirstName: firstName,
							LastName: lastName,
							Email: email,
							Country: country,
							Company: company,
							mktoindustry: this.getValueFromObject(myHiddenMetaData, industryTagValue),
							inferredMaterialInterest: this.getValueFromObject(myHiddenMetaData, materialTagValue),
							privacyPolicyAcceptance: true,
							mktooptinchkbxacceptance: true,
						});

						if (
							typeof firstName !== 'undefined' &&
							firstName.toString().length > 0 &&
							typeof lastName !== 'undefined' &&
							lastName.toString().length > 0 &&
							typeof email !== 'undefined' &&
							email.toString().length > 0 &&
							typeof country !== 'undefined' &&
							country.toString().length > 0 &&
							typeof company !== 'undefined' &&
							company.toString().length > 0
						) {
							myHiddenMktoForm.submit();
							this.hiddenSubmitForm(mktoFormId);
						}
					}
				}
			} else {
				if (hiddenCdcFormSubmitAllowed === 'true') {
					let requestData: SapCdcCdpContactExpertFormData = {
						primaryEmail: email,
						firstName: firstName,
						lastName: lastName,
						country: country,
						company: company,
						cov_submission_src: submissionSource,
						cov_submission_type: submissionType,
						cov_submission_date: '',
						cov_industry: encodeURIComponent(this.getValueFromObject(myHiddenMetaData, industryTagValue)),
						cov_lead_comments: formMessage,
						cov_form_url: encodeURIComponent(window.location.href),
						cov_cookie_id: localStorage.getItem('gig_cdp_gmid'),
						cov_inquiry_type: inquiryType,
						cov_material: encodeURIComponent(this.getValueFromObject(myHiddenMetaData, materialTagValue)),
						cdc_token_item_path: tokenOprationItemPath,
						cdc_set_acc_item_path: setAccinfoOprationItemPath,
						cov_campaign_id: campaignId,
					};
					$.ajax({
						url: window.location.origin + '/api/sapcdccdp/sendcontactexpertformdatatocdccdp',
						type: 'POST',
						contentType: 'application/json',
						data: JSON.stringify(requestData),
						success: (response: any) => {
							console.log('Response received from server:', response);
						},
						error: (xhr: any, status: any, error: any) => {
							console.error('Error occurred:', status, error);
						},
					});
				}
			}
		}

		if (!validate) {
			ev.preventDefault();
		}
		this.$ctx.addClass(classes.stateFormOrderHiddenAfterSubmit);
	}

	getValueFromObject(myMktoHiddenMetaData: any, materialTagValue: any): string {
		let title: string = '';
		myMktoHiddenMetaData.forEach((element: any) => {
			if (element.tagId === materialTagValue) {
				title = element.tagTitle.toString();
			}
		});
		return title;
	}

	onClickAnchor() {
		const formID = this.$ctx.attr('id');
		$('[href="#' + formID + '"]')
			.unbind('click')
			.on('click', (ev: Event) => {
				ev.preventDefault();
				this.onFocusAreaFocus();
				this.$ctx.find(`.${classes.focusElement}`).focus();
			});
	}

	onClickLink($el: JQuery) {
		const formID = this.$ctx.attr('id');
		$el.on('click', (ev: JQuery.Event) => {
			ev.preventDefault();
			const url = $el.attr('href');
			const anchorIdx = url.indexOf('#' + formID);
			if (anchorIdx != -1) {
				this.onFocusAreaFocus();
				this.$ctx.find(`.${classes.focusElement}`).focus();
			}
		});
	}

	prefillFormData() {
		const serviceUrl = this.$ctx.data('api-endpoint');

		if (serviceUrl) {
			$.ajax({
				method: 'get',
				url: serviceUrl,
				success: (jsonData: any) => {
					for (let key in jsonData) {
						const $input = this.$ctx.find('input[data-sc-field-name="' + key + '"]');
						$input.val(jsonData[key]);
						$input.trigger('change');
					}
				},
			});
		}
	}

	inputSelecteOptionChanged(ev: any) {
		const opt: string = ev.currentTarget.value.toLowerCase();
		const $target: any = $(ev.currentTarget);

		if ($target.val() !== '') {
			$target.removeClass('state-a-input--has-error');
			$target.nextAll('.field-validation-valid').text('');
			$target.nextAll('.field-validation-valid').removeClass('field-validation-error');
		} else {
			var dataValRequired = $target.attr('data-val');
			if (typeof dataValRequired !== 'undefined' && dataValRequired !== '' && dataValRequired !== null) {
				$target.addClass('state-a-input--has-error');
				$target.nextAll('.field-validation-valid').text($target.attr('data-val-required'));
				$target.nextAll('.field-validation-valid').addClass('field-validation-error');
			}
		}
		// Inquiry Type dropdown
		if ($target.hasClass(classes.inquiryTypeInputSelect)) {
			const $sdsLinkCol: any = this.$ctx.find(`.${classes.sdsLinkColumn}`);
			const $sdsTextboxCol: any = this.$ctx.find(`.${classes.inquiryTextboxColumn}`);

			let showCheckMark = false;
			// show SDS link
			if (opt === optionValues.productSafetyDataSheets) {
				$sdsLinkCol.css('display', 'flex');
				showCheckMark = true;
			} else {
				$sdsLinkCol.css('display', 'none');
			}

			// show SDS textbox
			if (opt === optionValues.other) {
				$('input[data-sc-field-name="otherInquiryType"]').val('');
				$sdsTextboxCol.show();
				showCheckMark = true;
			} else {
				$('input[data-sc-field-name="otherInquiryType"]').val('-');
				$sdsTextboxCol.hide();
			}

			if (showCheckMark) {
				$target.addClass(classes.inputSelectCheckMark);
			} else {
				$target.removeClass(classes.inputSelectCheckMark);
			}
		}

		// Category Type dropdown
		if ($target.hasClass(classes.inputSelectCategoryType)) {
			const $categoryInputContainer: any = this.$ctx.find(`.${classes.categoryInputContainer}`);
			const $firstInput: any = this.$ctx.find('.a-input-first .js-a-input--first-name');

			if (opt === optionValues.other.toLowerCase()) {
				$('input[data-sc-field-name="OtherCategory"]').val('');
				$categoryInputContainer.show();
				$target.addClass(classes.inputSelectCheckMark);
				setTimeout(() => {
					$categoryInputContainer
						.find(classes.categoryInputField)
						.focus()
						.select();
				}, 150);
			} else {
				$('input[data-sc-field-name="OtherCategory"]').val('-');
				$categoryInputContainer.hide();
				$target.removeClass(classes.inputSelectCheckMark);
				if ($firstInput.length > 0) {
					setTimeout(() => {
						if ($firstInput.val().length < 1) {
							$firstInput.focus().select();
						}
					}, 150);
				}
			}
		}
	}

	/**
	 * Add Other Optioin For MaterialTag field
	 * @returns {void}
	 */
	addOtherOptionForMaterialTag() {
		var otherText = $('#OtherText').val();
		var otherValue = $('#OtherValue').val();
		const $materialTag: any = this.$ctx.find('select[data-sc-field-name="materialTag"]');

		if ($materialTag.length > 0) {
			$('select[data-sc-field-name="materialTag"]').append(
				`<option value="${otherValue}" data-select2-id="10000">${otherText}</option>`
			);
		}
	}

	setMaterialTagDefaultValue() {
		var urlParams = new URLSearchParams(window.location.search);
		var meterialTag = $('#SelectTag').val();
		if (urlParams.has('materialtag')) {
			meterialTag = urlParams.get('materialtag');
		}
		$('select[data-sc-field-name="materialTag"]').val(meterialTag);
	}
	stop() {}
}
